









import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
// require styles
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

import { quillEditor } from 'vue-quill-editor';
import { QuillOptionsStatic } from 'quill';

@Component({
  name: 'text-editor',
  components: {
    quillEditor
  }
})
export default class TextEditor extends Vue {
  @Prop({ type: String, required: true })
  value!: string;

  @Prop({ type: Boolean, default: false })
  disabled!: boolean;

  editorOptions: QuillOptionsStatic = {};

  onChange({ html, text }: { html: string; text: string }) {
    this.$emit('input', html);
  }
}
